/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration200,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration401,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration404,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration500,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidResetIntegration.ts";

export const postApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidResetIntegration200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegration200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidResetIntegration401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegration401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1IndividualpaymentParcelsParcelidResetIntegration404Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegration404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidResetIntegration500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegration500>;

export const postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidResetIntegration200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse>;
